
import { defineComponent } from "vue";
import state from "@/store/state";

export default defineComponent({
  name: "Toast",
  data() {
    return {
      state: state
    };
  }
});
